import type { AustralianState } from '@urbanx/agx-ui-components'
import { StaffApi } from 'helpers'

interface RexSuburbSuggestion {
  stateOrRegion: AustralianState
  suburbOrTown: string
  postCode: string
}

export const getSuburbs = async (
  authToken: string,
  query: string,
  state: string,
  signal: AbortSignal
): Promise<RexSuburbSuggestion[]> => {
  const { data } = await new StaffApi('rex', authToken).post(
    'GetSuburbs',
    {
      listName: 'suburbs',
      searchString: query,
      state,
    },
    {},
    {},
    signal
  )

  return data as RexSuburbSuggestion[]
}
